import { Enum } from './Enum';

export default new Enum({
    NAO_DEFINIDO: { value: 0, text: ' ' },
    AGUARDANDO_PICKING: { value: 1, text: 'Aguardando Picking' },
    PICKING_EM_ANDAMENTO: { value: 2, text: 'Picking em Andamento' },
    AGUARDANDO_ARMAZENAGEM: { value: 3, text: 'Aguardando Armazenagem' },
    ARMAZENAGEM_EM_ANDAMENTO: { value: 4, text: 'Armazenagem em Andamento' }
});
